<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke
              :strankaImaFixPrikljucek="true"
              v-on:osvezitevIzbranSap="GetPrikljucek"
          />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div>
      <div class="vsebina-postavitev">
        <div class="odmik-vsebine">
          <p class="open-sans-30pt">
            Zgodovina naročil VOD
          </p>
          <div class="odmik-izbire-meseca">
            <p>
              Mesec
              <el-select v-model="izbranMesec" @change="GetVodInfo" class="odmik">
                <el-option v-for="mesecLeto in seznamMoznihMesecLet"
                           :value="mesecLeto.val"
                           :key="mesecLeto.val"
                           :label="mesecLeto.si_str">
                  {{ mesecLeto.si_str }}
                </el-option>
              </el-select>
            </p>
          </div>
          <br/>
          <span v-show="prikazTabele === '1'">
            <el-table :data="seznamPodatkov" width="100%" v-loading="loadingVsebine">
              <el-table-column prop="formatDatuma" label="Datum in čas izposoje" width="200px">
              </el-table-column>
              <el-table-column prop="description" label="Naslov vsebine" width="600px">
              </el-table-column>
              <el-table-column prop="charged_quantity" label="Količina">
              </el-table-column>
              <el-table-column prop="pretvorbaZnesek" label="Znesek v EUR (z DDV)">
              </el-table-column>
            </el-table>
          </span>
          <span v-show="prikazTabele === '0'">
            <el-table
              :data="seznamPodatkov"
              :current-page='2'
              :page-size='1'
              v-loading="loadingVsebine">
                <el-table-column>
                  <template slot-scope="props">
                    <p>
                      <span>
                      <b>
                        Datum in čas izposoje:
                      </b>
                      </span>
                      {{ props.row.formatDatuma}}
                    </p>
                    <p>
                      <span>
                        <b>
                            Naslov vsebine:
                        </b>
                      </span>
                      {{ props.row.description }}
                    </p>
                    <p>
                      <span>
                        <b>
                            Količina:
                        </b>
                      </span>
                      {{ props.row.charged_quantity }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Znesek v EUR (z DDV):
                        </b>
                      </span>
                      {{ props.row.pretvorbaZnesek }}
                    </p>
                  </template>
                </el-table-column>
            </el-table>
          </span>
          <div class="text-center">
            <br/>
            <el-pagination
              :hide-on-single-page="true"
              @current-change="PrikaziStran"
              :current-page="trenutnoIzbranaStran"
              :page-size="8"
              layout="prev, pager, next"
              :total="Number(dolzinaSeznamaZgodovinaVod)"
              small>
            </el-pagination>
          </div>
          <div>
            <span style="color: #080809;">
              <el-icon class="el-icon-info" style="font-size: 16px">
              </el-icon>
              <span style="padding-left: 4px" class="navadno-besedilo">
                Podatke o porabi v videoteki beležimo za zadnje tri mesece. Če imate naročeno
                videoteko v sklopu tržnega paketa ali kot dodatni TV paket,je izposoja vsebine iz
                videoteke brezplačna, še vedno pa bo v preglednici izpisan podatek o izposoji.
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {ObdelavaDatuma} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/IzbiraMeseca.js'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {DatePicker, Checkbox, Button, Select, Option, Pagination, TableColumn, Table, Tooltip} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {FormatDatuma} from '../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'
import Vue from 'vue'

export default {
  name: 'PorabaTelevizija',
  mixins: [PrikazVsebine, ObdelavaDatuma, FormatDatuma],
  components: {
    ObdelavaDatuma,
    'IzbirnikStranke': IzbirnikStranke,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Pagination.name]: Pagination,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
    [Tooltip.name]: Tooltip
  },
  data () {
    return {
      title: 'Zgodovina naročil VoD',
      clientAgent: null,
      loadingVsebine: false,
      seznamNarocnin: '',
      seznamMoznihMesecLet: [],
      seznamVod: [],
      izbranSap: '',
      izbranMesec: '',
      seznamPodatkov: [],
      dolzinaSeznamaZgodovinaVod: null,
      trenutnoIzbranaStran: 1,
      filter: '[tip_prikljucka]=FIX'
    }
  },
  watch: {
    izbranMesec: function () {
      if (this.izbranMesec !== '') {
        this.dolzinaSeznamaZgodovinaVod = null
        this.seznamPodatkov = []
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.DolociIzbranMesec()
    this.PrikazDatumZaIzbiro()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    GetPrikljucek (izbranSap) {
      if (izbranSap !== '') {
        this.izbranSap = izbranSap
        this.GetVodInfo()
        this.dolzinaSeznamaZgodovinaVod = 0
      }
    },
    PrikazDatumZaIzbiro () {
      this.seznamMoznihMesecLet = []
      let stMesecev = 3
      for (let i = stMesecev - 1; i >= 0; i--) {
        let d1 = new Date()
        d1.setMonth(d1.getMonth() - i)
        d1.si_str = d1.toLocaleString('sl-si', {month: 'long'}) + ' ' + d1.getFullYear().toString()
        d1.val = d1.getFullYear() + '-' + (d1.getMonth() + 1)
        this.seznamMoznihMesecLet.push(d1)
      }
      this.izbranMesec = this.seznamMoznihMesecLet[stMesecev - 1].val
    },
    GetVodInfo () {
      this.loadingVsebine = true
      let izbranoObdobje = this.DolociIzbranMesec(this.izbranMesec)
      let param = ['sap=' + this.izbranSap]
      param.push('datumOd=' + izbranoObdobje.trajanjeOd)
      param.push('datumDo=' + izbranoObdobje.trajanjeDo)
      this.clientAgent.postWsRequest(
        this,
        'mercury/vod',
        param,
        null,
        'SetVodInfo',
        '')
    },
    SetVodInfo (podatki) {
      this.seznamPodatkov = []
      if (podatki.data !== null && typeof podatki !== 'undefined' && podatki.data !==
        'undefined' && podatki.data.length > 0) {
        this.seznamVod = podatki.data
        for (let i = 0; i < this.seznamVod.length; i++) {
          let formatDatuma = this.PoenotenIzgledDatuma(this.seznamVod[i].date)
          Vue.set(this.seznamVod[i], 'formatDatuma', formatDatuma)
          this.davek = (100 + this.seznamVod[i].vat) / 100
          this.seznamVod[i].pretvorbaZnesek =
            (((this.seznamVod[i].amount * this.davek) / 100).toFixed(2).replace('.', ',') + ' €')
        }
        if (this.seznamVod !== null) {
          let tmpArray = []
          this.dolzinaSeznamaZgodovinaVod = this.seznamVod.length
          const chunk = 8
          for (let i = 0; i < this.dolzinaSeznamaZgodovinaVod; i += chunk) {
            tmpArray.push(this.seznamVod.slice(i, i + chunk))
          }
          this.seznamVod = tmpArray
          this.PrikaziStran(1)
        }
      } else {
        this.seznamVod = []
      }
      this.loadingVsebine = false
    },
    PrikaziStran (stran) {
      this.trenutnoIzbranaStran = stran
      if (typeof this.seznamVod[this.trenutnoIzbranaStran - 1] !== 'undefined') {
        this.seznamPodatkov = this.seznamVod[this.trenutnoIzbranaStran - 1]
      } else {
        this.seznamPodatkov = []
      }
      this.loadingVsebine = false
    }
  }
}
</script>
<style scoped src="../../../../../static/css/Poraba/PorabaTelevizija.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/PorabaTelevizija.vue